import { Icon } from "../../../../components/BaseComponents/Icon";

export const ConsoleIcon = (props) => (
	<Icon fill="none" viewBox="0 0 16 16" {...props}>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.75 3.78v8.44c.04.01.1.03.18.03h12.14c.08 0 .14-.02.18-.03V3.78a.47.47 0 0 0-.18-.03H1.93a.47.47 0 0 0-.18.03Zm-.91-1.2c.3-.22.7-.33 1.1-.33h12.13c.4 0 .78.11 1.1.33.3.23.58.6.58 1.09v8.66c0 .5-.28.86-.59 1.08-.3.23-.7.34-1.1.34H1.94c-.4 0-.78-.11-1.1-.34-.3-.22-.58-.59-.58-1.08V3.67c0-.5.28-.86.59-1.09Zm2.63 2.89c.3-.3.77-.3 1.06 0l2 2c.3.3.3.77 0 1.06l-2 2a.75.75 0 1 1-1.06-1.06L4.94 8 3.47 6.53a.75.75 0 0 1 0-1.06ZM7.25 10c0-.41.34-.75.75-.75h4a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75Z"
		/>
	</Icon>
);
